// @core/api/endpoints/tenant/get_tenant_quota.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantQuotaResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant quota
 * Returns the current resource quotas and usage for the tenant, including limits on members, storage, and other resources.
 */
export async function GetTenantQuota(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantQuotaResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/quota`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantQuotaResponse>(requestPath, { ...requestOptions });
}
